import React from "react";
import { BiSolidCoinStack } from "react-icons/bi";
import { FiUser } from "react-icons/fi";

import { useAuth } from "../../contexts/AuthContext.jsx";
import { useUserProfile } from "../../hooks/useApi";

export function TopBar() {
  const { user } = useAuth();
  const { data: userProfile, isRefetching } = useUserProfile();

  const credits = (userProfile?.credits_remaining || 0) + (userProfile?.topup_credits || 0);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 20px",
        borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
        backgroundColor: "#fff",
        flexShrink: 0,
      }}
    >
      {/* Logo */}
      <div
        onClick={() => (window.location.href = "/")}
        style={{
          fontWeight: 800,
          fontSize: "18px",
          color: "#000",
          letterSpacing: "-0.02em",
          cursor: "pointer",
        }}
      >
        scribbledraw.
      </div>

      {/* Account */}
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {user ? (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "5px 12px",
                fontSize: "13px",
                fontWeight: 500,
                color: "#333",
                backgroundColor: "#f5f5f5",
                borderRadius: "9999px",
              }}
            >
              <BiSolidCoinStack
                size={14}
                className={isRefetching ? "animate-spin" : ""}
              />
              <span>
                {isRefetching
                  ? "..."
                  : credits
                    ? credits.toLocaleString(undefined, {
                        maximumFractionDigits: 0,
                      })
                    : 0}
              </span>
            </div>
            <button
              onClick={() => (window.location.href = "/profile")}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "32px",
                height: "32px",
                backgroundColor: "#f5f5f5",
                border: "none",
                borderRadius: "9999px",
                cursor: "pointer",
                color: "#333",
              }}
            >
              <FiUser size={16} />
            </button>
          </>
        ) : (
          <button
            onClick={() => (window.location.href = "/profile")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "5px 14px",
              fontSize: "13px",
              fontWeight: 500,
              color: "#fff",
              backgroundColor: "#000",
              border: "none",
              borderRadius: "9999px",
              cursor: "pointer",
            }}
          >
            <FiUser size={14} />
            Sign In
          </button>
        )}
      </div>
    </div>
  );
}

export default TopBar;
